import { utils } from "ethers";
export { isAndroid, isMobile, isPhantomBrowser, isSafari } from "@lib/browser";
export var WalletExtension;
(function (WalletExtension) {
    WalletExtension["METAMASK"] = "metamask";
    WalletExtension["PHANTOM"] = "phantom";
    WalletExtension["WALLETCONNECT"] = "walletconnect";
})(WalletExtension || (WalletExtension = {}));
export var WalletError;
(function (WalletError) {
    WalletError["UNKNOWN_ERROR"] = "Unknown error";
    WalletError["METAMASK_NOT_INSTALLED"] = "Metamask wallet extension is not installed";
    WalletError["PHANTOM_NOT_INSTALLED"] = "Phantom wallet extension is not installed";
    WalletError["NOT_MAINNET"] = "Please switch to Ethereum Mainnet in your Metamask wallet extension";
    WalletError["UNSUPPORTED_NETWORK"] = "Unsupported network";
    WalletError["REQUEST_DENIED"] = "Request denied";
    WalletError["UNVERIFIED"] = "Unverified";
    WalletError["SAVE_FAILED"] = "Error saving wallet";
    WalletError["EXISTING_WALLET"] = "This wallet is registered by another user";
})(WalletError || (WalletError = {}));
export const signingMessage = () => {
    const nonce = utils.hexlify(utils.randomBytes(16));
    let message = "Welcome to MOONGATE!\n\n";
    message +=
        "By signing, you accept the MOONGATE Terms of Service:\nhttps://moongate.id/terms\n\n";
    message +=
        "This request will not trigger a blockchain transaction or cost any gas fees.\n\n";
    message += `To stop hackers using your wallet, here's a unique message ID they can't guess:\n${nonce}`;
    return message;
};
export var DeeplinkAction;
(function (DeeplinkAction) {
    DeeplinkAction["PHANTOM_CONNECT"] = "phantom_connect";
    DeeplinkAction["PHANTOM_SIGN_MESSAGE"] = "phantom_signMessage";
})(DeeplinkAction || (DeeplinkAction = {}));
